import { createFileRoute } from "@tanstack/react-router"
import DesignSystemTextStyles from "~/pages/design-system/styles/TextStyles"

export const Route = createFileRoute("/_auth/internal/design-system/styles/text-styles")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemTextStyles />
}
